import { render, staticRenderFns } from "./LoginSpecialForms.vue?vue&type=template&id=a61e6a22&scoped=true"
import script from "./LoginSpecialForms.vue?vue&type=script&lang=js"
export * from "./LoginSpecialForms.vue?vue&type=script&lang=js"
import style0 from "./LoginSpecialForms.vue?vue&type=style&index=0&id=a61e6a22&prod&scoped=true&lang=css"
import style1 from "./LoginSpecialForms.vue?vue&type=style&index=1&id=a61e6a22&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a61e6a22",
  null
  
)

export default component.exports